/**
 * Template control module
 */
import { requestData } from "../utils";
import { CreateTemplateData } from "../../../../dto/Template";

interface GetQuery {
  page: number;
  pageSize: number;
  enterprise_id: string;
  entity_id?: string;
}

interface Get {
  enterprise_id: string;
  entity_id?: string;
  template_id: string;
}

export default class TemplateModule {
  create(
    enterprise_id: string,
    template: CreateTemplateData,
    entity_id: string = "",
  ) {
    return requestData(
      "POST",
      `/bulk/template?enterprise_id=${enterprise_id}&entity_id=${entity_id}`,
      template,
    );
  }
  getQuery(query: GetQuery) {
    return requestData("GET", `/bulk/query/template`, {
      ...query,
    });
  }
  get(query: Get) {
    return requestData("GET", `/bulk/template`, {
      ...query,
    });
  }
  update({ enterprise_id, template, entity_id = "" }) {
    return requestData(
      "PUT",
      `/bulk/template?enterprise_id=${enterprise_id}&template_id=${template.template_id}&entity_id=${entity_id}`,
      {
        ...template,
      },
    );
  }
  delete({ enterprise_id = "", template_id = "", entity_id = "" }) {
    return requestData(
      "DELETE",
      `/bulk/template?enterprise_id=${enterprise_id}&template_id=${template_id}&entity_id=${entity_id}`,
    );
  }
}
